import axios from "axios";
import { baseURL } from "../config/api";

export const getCustomerServices = () => {
    return getFetch(`services`)
}

export const post_AdditionalServices = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}additionalAppointmentServices?userId=${userId}`,
        method: "POST",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}

export const put_AdditionalServices = (data: any, userId: number) => {
    return axios({
        url: `${baseURL}additionalAppointmentServices?userId=${userId}`,
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        withCredentials: false,
        data: data
    }).then(response => response.data);
}



export const delete_AdditionalServices = (id: number, userId: number) => {
    return axios({
        url: `${baseURL}additionalAppointmentServices?id=${id}&userId=${userId}`,
        method: "DELETE"
    }).then(response => response.data);
}


const getFetch = (url: string, params = {}) => {
    return axios({
        url: baseURL + url,
        method: "GET",
        params: params
    }).then(response => response.data);
}